export const PromoDealOffersActionsTexts = {
  getInApp: 'Получить займ в приложении',
  continueWebsite: 'Продолжить на сайте',
};
